export const translations = {
  bg: {
    // Fold component
    dearGuests: "Скъпи гости,",
    we: "ние,",
    brideName: "КАТЕРИНА",
    groomName: "ИЛИАН",
    invitationText: "с много любов и вълнение ви каним да споделите с нас деня, в който две сърца ще поемат общ път и ще се врекат във вечна и безрезервна любов.",
    june: "юни",

    // Content component
    program: "ПРОГРАМА",
    withLove: "с обич:",
    copyright: "Copyright ©2025 Сватбена покана",
    author: "Автор: Булката",

    // EngagedSection component
    presenceText: "Присъствието ви ще придаде още повече смисъл и красота на този незабравим за нас ден.",
    locationText: "Очакваме ви с любов и усмивки в",
    restaurantName: `Ресторант "Печката" - к.к. Св. Св. Констаинтин и Елена.`,
    confirmByText: "Молим да потвърдите присъствието си за всеки член от семейството",
    confirmByDate: "до 31 Март, 2026г.",
    confirmBtn: "ПОТВЪРДИ",
    confirmBtnMobile: "ПРИСЪСТВИЕ",
    confirmFormText: "Моля,",
    confirmFormBold: "попълнете формуляра в края на поканата",
    confirmFormEnd: ", за да потвърдите своето присъствие.",

    // Schedule component
    ourSpecialDay: "НАШИЯТ СПЕЦИАЛЕН ДЕН",
    scheduleQuote: `"Там, където морето целува брега и лятото ни прегръща с аромат на кокос и бели орхидеи, започва нашата история завинаги..."`,
    restaurantLocation: `РЕСТОРАНТ "ПЕЧКАТА", К.К. СВ. СВ. КОНСТАНТИН И ЕЛЕНА`,
    welcomeDrink: "Welcome drink",
    weddingCeremony: "Сватбена Церемония",
    photosAndGreetings: "Снимки и поздравления",
    festivalDinner: "Празнична Вечеря",
    weddingCake: "Сватбена торта",
    time17: "17:00 ч.",
    time18: "18:00 ч.",
    time1830: "18:30 ч.",
    time1930: "19:30 ч.",
    time22: "22:00 ч.",

    // Transport component
    contactQuestion: "С кого да се свържа в деня на сватбата?",
    contactText: "При възникнали въпроси от всякакво естество в деня на сватбата, можете да се свържете с нашия сватбен агент:",
    weddingAgent: "Симона Кирилова:",
    howToGetThere: "Как да стигна?",
    locationDescription: `Локацията, която избрахме за нашия сватбен ден е Ресторант „Печката", който се намира в морския курорт Св. Св. Константин и Елена.`,
    hotelInfo: `За гостите, които живеят извън гр. Варна, са предвидени преференциални цени с предварителна резервация за хотел „Astor Garden".`,
    hotelDistance: "Хотелът се намира на 350м. от ресторанта. За резервации и уточняване на броя и вида на необходимите стаи, моля да се свържете с Булката:",
    bride: "Булката:",
    restaurantNameShort: `Ресторант „Печката"`,
    locationShort: "к.к. Св. Св. Константин и Елена, обл. Варна",
    mapNote: `(Цъкни върху "View larger map")`,

    // Counter component
    remaining: "ОСТАВАТ",
    days: "ДНИ",
    hours: "ЧАСА",
    minutes: "МИН.",
    seconds: "СЕК.",
    timeHasCome: "НАСТАНА ВРЕМЕ!",
    confirmPresence: "ПОТВЪРДИ",
    confirmPresenceMobile: "ПРИСЪСТВИЕ",
    confirmByShort: "до 31 Март, 2026г.",

    // ConfirmationContainer component
    confirmPresenceTitle: "ПОТВЪРДИ ПРИСЪСТВИЕ",
    confirmByFull: "Молим да потвърдите присъствието си",
    deadline: "до 31 Март, 2026г.",
    confirmForAnotherGuest: "Искаш да потвърдиш за друг гост?",
    addGuest: "ДОБАВИ ГОСТ",

    // Godparents component
    godparents: "КУМОВЕ",
    godparentsFamily: "сем. Панайотови",
    godparentsText: "Ще кажем своето",
    godparentsYes: `„Да"`,
    godparentsText2: ", водени и благословени от хората, които ще застанат до нас като наши кумове –",
    godparentsNames: "Катерина и Васил",
    godparentsText3: "Панайотови, свидетели на любовта и пазители на нашия обет.",

    // ConfirmForm component
    firstName: "Име*",
    lastName: "Фамилия*",
    email: "Имейл",
    canYouAttend: "Ще можеш ли да присъстваш?*",
    yes: "Да",
    noSorry: "Не, съжалявам",
    forGuestsOutsideVarna: "За гостите, които живеят извън гр. Варна:",
    hotelQuestion: `Желаете ли да Ви съдействаме с резервация за хотел „Astor Garden"?`,
    preferentialPrices: "(за сватбата са предвидени",
    preferentialPricesBold: "преференциални цени",
    preferentialPricesEnd: ")",
    hotelContactText: "За резервации и уточняване на броя и вида на необходимите стаи, молим да се свържете с Булката на тел. номер:",
    submit: "ИЗПРАТИ",
    thankYou: "Благодарим за отделеното време.",
    confirmedSuccess: "успешно потвърди присъствието си на нашата сватба :)",
    blackMark: "получи черна точка ;/",
    alertMissing: "Упс, май забрави да попълниш нещо?",
    alertError: "Възникна грешка. Моля опитайте пак или се свържете с нас, за да я поправим!",
  },

  en: {
    // Fold component
    dearGuests: "Dear guests,",
    we: "we,",
    brideName: "KATERINA",
    groomName: "ILIAN",
    invitationText: "with great love and excitement, invite you to share with us the day when two hearts will embark on a common path and vow eternal and unconditional love.",
    june: "June",

    // Content component
    program: "SCHEDULE",
    withLove: "with love:",
    copyright: "Copyright ©2025 Wedding Invitation",
    author: "Created by: The Bride",

    // EngagedSection component
    presenceText: "Your presence will add even more meaning and beauty to this unforgettable day for us.",
    locationText: "We await you with love and smiles at",
    restaurantName: `Restaurant "Pechkata" - Saints Constantine and Helena Resort.`,
    confirmByText: "Please confirm your attendance for each family member",
    confirmByDate: "by March 31st, 2026.",
    confirmBtn: "CONFIRM",
    confirmBtnMobile: "ATTENDANCE",
    confirmFormText: "Please",
    confirmFormBold: "fill out the form at the end of the invitation",
    confirmFormEnd: " to confirm your attendance.",

    // Schedule component
    ourSpecialDay: "OUR SPECIAL DAY",
    scheduleQuote: `"Where the sea kisses the shore and summer embraces us with the scent of coconut and white orchids, our forever story begins..."`,
    restaurantLocation: `RESTAURANT "PECHKATA", SAINTS CONSTANTINE AND HELENA RESORT`,
    welcomeDrink: "Welcome drink",
    weddingCeremony: "Wedding Ceremony",
    photosAndGreetings: "Photos and Greetings",
    festivalDinner: "Festive Dinner",
    weddingCake: "Wedding Cake",
    time17: "5:00 PM",
    time18: "6:00 PM",
    time1830: "6:30 PM",
    time1930: "7:30 PM",
    time22: "10:00 PM",

    // Transport component
    contactQuestion: "Who should I contact on the wedding day?",
    contactText: "If you have any questions of any nature on the wedding day, you can contact our wedding coordinator:",
    weddingAgent: "Simona Kirilova:",
    howToGetThere: "How to get there?",
    locationDescription: `The location we chose for our wedding day is Restaurant "Pechkata", which is located in the seaside resort of Saints Constantine and Helena.`,
    hotelInfo: `For guests living outside the city of Varna, preferential prices are available with advance reservation at the "Astor Garden" hotel.`,
    hotelDistance: "The hotel is located 350m from the restaurant. For reservations and to specify the number and type of rooms needed, please contact the Bride:",
    bride: "The Bride:",
    restaurantNameShort: `Restaurant "Pechkata"`,
    locationShort: "Saints Constantine and Helena Resort, Varna region",
    mapNote: `(Click on "View larger map")`,

    // Counter component
    remaining: "REMAINING",
    days: "DAYS",
    hours: "HOURS",
    minutes: "MIN.",
    seconds: "SEC.",
    timeHasCome: "THE TIME HAS COME!",
    confirmPresence: "CONFIRM",
    confirmPresenceMobile: "ATTENDANCE",
    confirmByShort: "by March 31st, 2026",

    // ConfirmationContainer component
    confirmPresenceTitle: "CONFIRM ATTENDANCE",
    confirmByFull: "Please confirm your attendance",
    deadline: "by March 31st, 2026.",
    confirmForAnotherGuest: "Would you like to confirm for another guest?",
    addGuest: "ADD GUEST",

    // Godparents component
    godparents: "BEST MAN & MAID OF HONOR",
    godparentsFamily: "The Panayotov Family",
    godparentsText: "We will say our",
    godparentsYes: `"I do"`,
    godparentsText2: ", guided and blessed by the people who will stand by us as our best man and maid of honor –",
    godparentsNames: "Katerina and Vasil",
    godparentsText3: "Panayotovi, witnesses of love and keepers of our vow.",

    // ConfirmForm component
    firstName: "First Name*",
    lastName: "Last Name*",
    email: "Email",
    canYouAttend: "Will you be able to attend?*",
    yes: "Yes",
    noSorry: "No, I'm sorry",
    forGuestsOutsideVarna: "For guests living outside the city of Varna:",
    hotelQuestion: `Would you like us to assist you with a reservation at the "Astor Garden" hotel?`,
    preferentialPrices: "(for the wedding,",
    preferentialPricesBold: "preferential prices ",
    preferentialPricesEnd: "are available)",
    hotelContactText: "For reservations and to specify the number and type of rooms needed, please contact the Bride at:",
    submit: "SUBMIT",
    thankYou: "Thank you for your time.",
    confirmedSuccess: "successfully confirmed attendance at our wedding :)",
    blackMark: "received a black mark ;/",
    alertMissing: "Oops, looks like you forgot to fill something out?",
    alertError: "An error occurred. Please try again or contact us to fix it!",
  }
};
